// extracted by mini-css-extract-plugin
module.exports = {"crown":"crown_crown__qX1ar"};